import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    height: 'calc(1.1875em + 3px)',
  },
}));
